"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    RelativeDate: function() {
        return RelativeDate;
    },
    toRelativeDateString: function() {
        return toRelativeDateString;
    }
});
const _localisationeq1 = require("@equiem/localisation-eq1");
const _luxon = require("luxon");
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const toRelativeDateString = (param, t)=>{
    let { datetime, timezone, language } = param;
    const today = Number(_luxon.DateTime.local({
        zone: timezone
    }).toFormat("d"));
    const date = _luxon.DateTime.fromMillis(datetime, {
        zone: timezone
    });
    const dayDiff = Number(date.toFormat("d")) - today;
    const dateDisplay = dayDiff === 0 ? t("common.today").toUpperCase() : dayDiff === 1 ? t("common.tomorrow").toUpperCase() : "".concat(_localisationeq1.formatters.datelong(date, language)).toUpperCase();
    return dateDisplay;
};
const RelativeDate = (props)=>{
    const { t } = (0, _localisationeq1.useTranslation)();
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, toRelativeDateString(props, t));
};

//# sourceMappingURL=RelativeDate.js.map